import React, { useState } from "react";
import { useSetting } from "../../context/SettingContext";

// import JS files
// import { reverseShowNums, showNumSix } from "../../constants/constants";

// import Others files

const SizeTextGrid = (props) => {
  const {showNumSix,reverseShowNums} = useSetting()
  let windowWidth = window.screen.width;
  return (
    <>
      <div className="md:px-4 md:py-2 mt-2">
        <div className={`grid md:grid-cols-${props.have5Col ? 5 : 6}`}>
          <div
            className={`md:col-span--${
              props.have5Col ? 1 : 2
            } text-sm flex justify-center items-center mb-4 md:mb-0`}
          >
            {props.haveTotalWeight ? (
              <div className="md:mx-2 md:my-1 text-purple-700 ">
                <span>جمع وزن کل سفارش شما:</span>
                <span className="font-bold mr-4">
                  {props.get_total_weight()} گرم
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="md:col-span-4 ">
            <div className="flex md:hidden justify-center text-sm mb-4 text-slate-500">
              <span>راهنمای فیلد سایزها:</span>
            </div>
            <div className="md:grid grid-cols-12 gap-x-2 items-center">
              {props.haveExtraCol && <div className="md:col-span-1"></div>}
              <div className="md:col-span-8 text-center  ">
                <div className="grid grid-cols-3 md:grid-cols-7 gap-y-2 md:gap-y-0">
                  <div className="hidden md:block">
                    <p className="text-center text-xs md:text-sm ">سایز:</p>
                  </div>
                  {reverseShowNums ? (
                    <div className="col-span-6 grid grid-cols-3 md:grid-cols-6 gap-2">
                      {showNumSix ? (
                        <div className=" mr-2">
                          <p className=" text-center text-xs md:text-sm">6</p>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className=" mr-2">
                        <p className=" text-center text-xs md:text-sm">5</p>
                      </div>
                      <div className=" mr-2">
                        <p className=" text-center text-xs md:text-sm">4</p>
                      </div>
                      <div className=" mr-2">
                        <p className=" text-center text-xs md:text-sm">3</p>
                      </div>
                      <div className=" mr-2">
                        <p className=" text-center text-xs md:text-sm">2</p>
                      </div>
                      <div className=" mr-2">
                        <p className=" text-center text-xs md:text-sm">1</p>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="mr-2">
                        <p className=" text-center text-xs md:text-sm">1</p>
                      </div>
                      <div className="mr-2">
                        <p className=" text-center text-xs md:text-sm">2</p>
                      </div>
                      <div className="mr-2">
                        <p className=" text-center text-xs md:text-sm">3</p>
                      </div>
                      <div className="mr-2">
                        <p className=" text-center text-xs md:text-sm">4</p>
                      </div>
                      <div className="mr-2">
                        <p className=" text-center text-xs md:text-sm">5</p>
                      </div>
                      {showNumSix ? (
                        <div className="mr-2">
                          <p className=" text-center text-xs md:text-sm">6</p>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              </div>
              <div
                className={
                  props.haveExtraCol ? "md:col-span-3" : "md:col-span-4"
                }
              >
                <div className="mr-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SizeTextGrid;
